import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js'

import "../../assets/css/spinkit.css";

class Loader extends Component {
    componentWillReceiveProps(nextProps) {
        if (nextProps.isLoading) {
            setTimeout(() => {
                if (this.props.isLoading) {
                    Raven.captureMessage('Very long load time', {
                        level: 'warning'
                    });
                }
            }, 15000);
        }
    }

    render() {
        const spin = !!this.props.spin;
        return (
            <div>
                {
                    this.props.isLoading ? (
                        <div>
                            {
                                spin ? (
                                    <div className={"sk-circle"}>
                                        <div className="sk-circle1 sk-child"></div>
                                        <div className="sk-circle2 sk-child"></div>
                                        <div className="sk-circle3 sk-child"></div>
                                        <div className="sk-circle4 sk-child"></div>
                                        <div className="sk-circle5 sk-child"></div>
                                        <div className="sk-circle6 sk-child"></div>
                                        <div className="sk-circle7 sk-child"></div>
                                        <div className="sk-circle8 sk-child"></div>
                                        <div className="sk-circle9 sk-child"></div>
                                        <div className="sk-circle10 sk-child"></div>
                                        <div className="sk-circle11 sk-child"></div>
                                        <div className="sk-circle12 sk-child"></div>
                                    </div>
                                ) : (
                                    <div className={"sk-folding-cube"}>
                                        <div className="sk-cube1 sk-cube"></div>
                                        <div className="sk-cube2 sk-cube"></div>
                                        <div className="sk-cube4 sk-cube"></div>
                                        <div className="sk-cube3 sk-cube"></div>
                                    </div>
                                )
                            }
                        </div>
                    ) : (
                        <div>
                            {this.props.children}
                        </div>
                    )
                }
            </div>
        );
    }
}

Loader.propTypes = {
    isLoading: PropTypes.bool.isRequired
};

export default Loader;


// WEBPACK FOOTER //
// ./src/components/display/Loader.js